export default __webpack_public_path__ + "assets/favicons/favicon-alert-32x32.png";